<template>
  <section class="content">
    <a hidden href="#" id ="openPayload" data-toggle="modal" data-target="#payload-modal"></a>
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>
    <template v-if="notFound">
      <div class="error-page">
        <h2 class="headline text-danger"> 404</h2>
        <div class="error-content">
          <h3><i class="fa fa-warning text-danger"></i> Oops! Order not found.</h3>
          <p>
            We could not find the order you were looking for.
            Meanwhile, you may <a href="/home">return to dashboard</a> or try using the search form.
          </p>
          <form @submit.prevent="$router.push('/orders/' + goto)" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" :placeholder="'goto_order' | translate" v-model="goto">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
          <br>
          <form @submit.prevent="goToMp()" class="search-form">
            <div class="input-group">
              <input type="text" name="search" class="form-control" placeholder="zu MP ID springen" v-model="gotoMP">
              <div class="input-group-btn">
                <button type="submit" name="submit" class="btn btn-danger"><i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row" v-if="errorLabel !== 0">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="box box-danger box-solid">
            <div class="box-header with-border">
              <h3 class="box-title"><i class="fa fa-exclamation-triangle mr-5"></i>{{'label_errors' | translate}}</h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>Information</th>
                    <th>Status</th>
                    <th class="text-center">Retry</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <div v-for="message in messages" @click="payload" class="alert alert-danger" style="margin-bottom: 5px !important">
                        <span><i class="fa fa-exclamation-triangle mr-5"></i>{{message}}</span>
                      </div>
                    </td>
                    <td>{{errorLabel.status}}</td>
                    <td class="text-center"><button class="btn btn-sm btn-info no-margin" @click="retry(errorLabel.id)"><i class="fa fa-refresh"></i></button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="box-footer"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="modal fade" id="payload-modal" tabindex="-1" role="dialog" aria-labelledby="payloadModalLabel" style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Information</h4>
              </div>
              <div class="modal-body">
                <p><strong>Payload:</strong><br/> <pre>{{errorLabel.payload}}</pre></p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
              </div>
            </div>
          </div>
        </div>
        <sap-doc-history-modal :sapdochistory="this.sapdochistory"></sap-doc-history-modal>
        <return-modal @action="returnOrder($event)"></return-modal>
        <refund-modal @action="refundOrder($event)" :images="imagesForRefund"></refund-modal>
        <refund-modal-2 :line="selectedLine" @success="success"></refund-modal-2>
        <refund-modal-3 @action="sendRefund($event)" @alert="alert($event)"></refund-modal-3>
        <cancel-modal @action="cancelOrder($event)" :reason="'out_of_stock'"></cancel-modal>
        <edit-modal :id="'edit-shipping'" :mode="'shipping'" :addressForComp="order.customer" @alert="alert($event)"></edit-modal>
        <edit-modal :id="'edit-billing'" :mode="'billing'" :addressForComp="order.customer" @alert="alert($event)"></edit-modal>
<!--        <div class="modal fade" id="item-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">-->
<!--          <div class="modal-dialog" role="document">-->
<!--            <div class="modal-content">-->
<!--              <div class="modal-header">-->
<!--                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
<!--                <h4 class="modal-title" id="item_ModalLabel"><i class="fa fa-calendar-o mr-5"></i>{{'history' | translate}}</h4>-->
<!--              </div>-->
<!--              <div class="modal-body">-->
<!--                <order-history :transitions="selectedTransitions" :storeTransitions="storeTransitions" :main="false"></order-history>-->
<!--              </div>-->
<!--              <div class="modal-footer">-->
<!--                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="modal fade" id="store-history" tabindex="-1" role="dialog" aria-labelledby="store-history_ModalLabel" style="display: none;">-->
<!--          <div class="modal-dialog" role="document">-->
<!--            <div class="modal-content">-->
<!--              <div class="modal-header">-->
<!--                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
<!--                <h4 class="modal-title"><i class="fa fa-calendar-o mr-5"></i>{{'history' | translate}}</h4>-->
<!--              </div>-->
<!--              <div class="modal-body">-->
<!--                <store-history :transitions="storeTransitions"></store-history>-->
<!--              </div>-->
<!--              <div class="modal-footer">-->
<!--                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="modal fade" id="label-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">-->
<!--          <div class="modal-dialog modal-labels" role="document">-->
<!--            <div class="modal-content">-->
<!--              <div class="modal-header">-->
<!--                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>-->
<!--                <h4 class="modal-title"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</h4>-->
<!--              </div>-->
<!--              <div class="modal-body">-->
<!--                <label-history :transitions="selectedLabelTransitions" :shipping="selectedShipping" :returnCode="selectedReturn"></label-history>-->
<!--              </div>-->
<!--              <div class="modal-footer">-->
<!--                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="row">
        <div class="modal fade" id="reminder-modal" tabindex="-1" role="dialog" aria-labelledby="payloadModalLabel" style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeReminder"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-bell-o mr-5"></i>Retouren Erinnerung</h4>
              </div>
              <div class="modal-body">
                <div class="margin"></div>
                <label>{{'commentary' | translate}}:</label>
                <textarea class="form-control" v-model="returnMessage"></textarea>
              </div>
              <div class="modal-footer">
                <b-btn :disabled="returnMessage === ''" @click="updateRecordedReturn" type="button" class="btn btn-app no-margin btn-success"><i class="fa fa-save"></i>{{'submit' | translate}}</b-btn>
                <button type="button" class="btn btn-app no-margin btn-outline pull-left" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <return-modal @action="returnOrder($event)"></return-modal>
        <refund-modal @action="refundOrder($event)" :images="imagesForRefund"></refund-modal>
        <refund-modal-2 :line="selectedLine" @success="success"></refund-modal-2>
        <cancel-modal @action="cancelOrder($event)" :reason="'out_of_stock'"></cancel-modal>
        <edit-modal :id="'edit-shipping'" :mode="'shipping'" :addressForComp="order.customer" @alert="alert($event)"></edit-modal>
        <edit-modal :id="'edit-billing'" :mode="'billing'" :addressForComp="order.customer" @alert="alert($event)"></edit-modal>
        <div class="modal fade" id="item-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title" id="forgot_ModalLabel"><i class="fa fa-calendar-o mr-5"></i>{{'history' | translate}}</h4>
              </div>
              <div class="modal-body">
                <order-history :transitions="selectedTransitions" :main="false"></order-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="store-history" tabindex="-1" role="dialog" aria-labelledby="store-history_ModalLabel" style="display: none;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-calendar-o mr-5"></i>{{'history' | translate}}</h4>
              </div>
              <div class="modal-body">
                <store-history :transitions="storeTransitions"></store-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="label-history" tabindex="-1" role="dialog" aria-labelledby="item-history_ModalLabel" style="display: none;">
          <div class="modal-dialog modal-labels" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</h4>
              </div>
              <div class="modal-body">
                <label-history :transitions="selectedLabelTransitions" :shipping="selectedShipping" :returnCode="selectedReturn"></label-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="paymentHistory" tabindex="-1" role="dialog"
             aria-labelledby="item-history_ModalLabel" style="display: none;">
          <div class="modal-dialog modal-labels" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                  aria-hidden="true">×</span></button>
                <h4 class="modal-title"><i class="fa fa-money mr-5"></i>{{'payment_history' |
                  translate}}</h4>
              </div>
              <div class="modal-body">
                <payment-history :payments="payments"></payment-history>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline" data-dismiss="modal"><span
                  class="fa fa-times mr-5"></span>{{'cancel' |
                  translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{'order_details' | translate}}</h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div class="box-controls">
              <template v-if="loading">
                <div class="row">
                  <div class="col-xs-12 text-center">
                    <img class="loading-gif" src="/static/img/blabla.svg"/>
                  </div>
                </div>
              </template>
              <div class="row" v-else>
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                  <h4>
                    {{'shipping_address' | translate}}
                    <button class="btn btn-info btn-xs pull-right" type="button" data-toggle="modal" data-target="#edit-shipping" aria-expanded="false" aria-controls="edit-billing">
                      <i class="fa fa-edit mr-5"></i>{{'edit' | translate}}
                    </button>
                  </h4>
                  <hr>
                  <h5>{{order.customer.corrected_first_name !== ''? order.customer.corrected_first_name : order.customer.delivery_first_name}} {{order.customer.corrected_last_name !== ''? order.customer.corrected_last_name : order.customer.delivery_last_name}}</h5>
                  <p v-if="order.customer.corrected_street === ''">{{order.customer.delivery_address_line_1}}
                    <template v-if="order.customer.delivery_address_line_2 !== ''">
                      <br><span v-html="this.getObjectData(order.customer.delivery_address_line_2)"></span>
                    </template>
                    <template v-if="order.customer.delivery_address_line_3 !== ''">
                      <br>{{order.customer.delivery_address_line_3}}
                    </template>
                    <br>{{order.customer.delivery_zip_code}} {{order.customer.delivery_city}}<br>{{order.customer.delivery_country | country}}
                  </p>
                  <p v-else>
                    {{order.customer.corrected_street}} {{order.customer.corrected_street_number}} <br>
                    {{order.customer.corrected_zip}} {{order.customer.corrected_city}}
                  </p>
                  <p class="small text-muted">
                    <i class="fa fa-envelope mr-5"></i> <a :href="'mailto:' + order.customer.customer_email">{{order.customer.customer_email}}</a>
                    <br>
                    <template v-if="order.customer.customer_phone_number && order.customer.customer_phone_number">
                      <i class="fa fa-phone mr-5"></i> <a :href="'tel:' + order.customer.customer_phone_number">{{order.customer.customer_phone_number}}</a>
                    </template>
                  </p>
                  <div class="clearfix margin"></div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                  <h4>
                    {{'billing_address' | translate}}
                    <button class="btn btn-info btn-xs pull-right" type="button" data-toggle="modal" data-target="#edit-billing" aria-expanded="false" aria-controls="edit-billing">
                      <i class="fa fa-edit mr-5"></i>{{'edit' | translate}}
                    </button>
                  </h4>
                  <hr>
                  <h5>{{order.customer.billing_salutation}}{{order.customer.billing_first_name}} {{order.customer.billing_last_name}}</h5>
                  <p>{{order.customer.billing_address_line_1}}
                    <template v-if="order.customer.billing_address_line_2 !== ''">
                      <br>{{order.customer.billing_address_line_2}}
                    </template>
                    <template v-if="order.customer.billing_address_line_3 !== ''">
                      <br>{{order.customer.billing_address_line_3}}
                    </template>
                    <br>{{order.customer.billing_zip_code}} {{order.customer.billing_city}}<br>{{order.customer.billing_country | country}}</p>
                  <p class="small text-muted">
                    <i class="fa fa-envelope mr-5"></i> <a :href="'mailto:' + order.customer.customer_email">{{order.customer.customer_email}}</a>
                    <br>
                    <template v-if="order.customer.customer_phone_number && order.customer.customer_phone_number">
                      <i class="fa fa-phone mr-5"></i> <a :href="'tel:' + order.customer.customer_phone_number">{{order.customer.customer_phone_number}}</a>
                    </template>
                  </p>
                  <div class="clearfix margin"></div>
                </div>
                <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 pull-left">
                  <ul class="list-group list-group-unbordered">
                    <li class="list-group-item"><b>{{'order_number' | translate}}: </b>{{order.sales_channel === 'schuhede-mirapodo' || order.sales_channel === 'mirapodo' ? order.ext_order_id_addition : order.ext_order_id}}</li>
                    <li class="list-group-item"><b>{{'date' | translate}}: </b>{{order.order_date | orderDate}} <small class="text-muted">{{order.order_date | orderDate(true)}}</small></li>
                    <li class="list-group-item"><b>{{'client' | translate}}: </b>{{order.customer.customer_id}} <small class="text-muted">{{order.customer.delivery_first_name}} {{order.customer.delivery_last_name}}</small></li>
                    <li class="list-group-item"><b>{{'order_total' | translate}}: </b>{{order.order_total | currency}}
                      <button class="btn btn-flat btn-info btn-xs pull-right" type="button" data-toggle="modal" data-target="#paymentHistory"
                              @click="openPaymentHistoryModal(order.id)">
                      <i class="fa fa-money mr-5"></i>
                      {{'payment_history'|translate}}
                    </button>
                    </li>
                    <li class="list-group-item"><b>{{'payment_method' | translate}}: </b>{{order.payment_method}}</li>
                    <li class="list-group-item"><b>{{'marketplace' | translate}}: </b><i :class="getIcon(order.sales_channel)"></i> {{order.sales_channel | translate}}</li>
                  </ul>
                  <template v-if="$store.getters.user.roles.admin === true">
                    <button class="btn btn-flat btn-danger mb-10 pull-right" @click="reIndexOrder(order.id)">
                      <i class="fa fa-refresh mr-5"></i> {{'reindex_order' | translate}}
                    </button>
                  </template>
                </div>
              </div>
              <div class="row" v-if="order && order.customer_comment !== ''">
                <div class="attachment-block clearfix">
                  <p>
                    <strong>
                      <i class="fa fa-comment mr-5"></i>{{'customer_comment' | translate}}</strong>
                  </p>
                  <p class="small mb-10">{{order.customer_comment}}</p>
                </div>
              </div>
            </div>
            <div class="box-body">
              <template v-for="store in enhancedOrder.stores">
                <div class="row">
                  <div class="col-xs-12 mb-10">
                    <small class="ml-5">
                      <span class="fa fa-chevron-down mr-5"></span>{{'booked_from' | translate}}: {{`${store.name} -  ${store.street} ${store.street_no} - ${store.zip_code},  ${store.city}`}}
                      <span class="italic"> - <a :href="`/accounting/companies/${store.company_id}`" target="_blank">{{store.name}}</a></span>
                      <span class="ml-5 mr-5">-</span>
                      <template v-if="editPhone">
                        <input type="text" v-model="store.phone_number" class="normal">
                        <a @click="() => {sendEdit(store.company_id, {qb_phone_contact: store.phone_number}); editPhone = false}"><i class="fa fa-check ml-5 mr-5"></i></a>
                      </template>
                      <template v-else>
                        <span><i class="fa fa-phone mr-5"></i><a :href="`tel:${store.phone_number}`">{{store.phone_number}}</a><a @click="() => {editPhone = true}"><i class="fa fa-edit ml-5"></i></a></span>
                      </template>
                      <template v-if="editMail">
                        <input type="text" v-model="store.email" class="normal">
                        <a @click="() => {sendEdit(store.company_id, {qb_email_contact: store.email}); editMail = false}"><i class="fa fa-check ml-5 mr-5"></i></a>
                      </template>
                      <template v-else>
                        <span class="ml-5 mr-5">-</span> <span><i class="fa fa-at mr-5"></i><a :href="`mailto:${store.email}`" target="_top">{{store.email}}</a><a @click="() => {editMail = true}"><i class="fa fa-edit ml-5"></i></a></span>
                      </template>
                    </small>
                    <div class="clearfix mb-10"></div>
                    <div v-if="store.shippings.length > 0">
                      <template v-for="shipping, i in store.shippings">
                        <div class="btn-group no-padding btn-sm">
                          <label class="btn mr-5"><i class="fa fa-files-o mr-5"></i>{{'shipping_docs' | translate}} - {{'shipment' | translate}} {{i+1}}:</label>
                          <a class="btn btn-outline" :href="shipping.combined_path_documents" target="_blank"><i class="fa fa-print mr-5"></i>{{'combined_documents' | translate}}</a>
                          <a v-if="shipping.combined_return_path !== ''" class="btn btn-outline" :href="shipping.combined_return_path" target="_blank"><i class="fa fa-print mr-5"></i>{{'combined_return' | translate}}</a>
                          <a class="btn btn-outline" :href="shipping.delivery_information_path" target="_blank"><i class="fa fa-print mr-5"></i>{{'delivery_information' | translate}}</a>
                          <a class="btn btn-outline" :href="shipping.return_information_path" target="_blank"><i class="fa fa-print mr-5"></i>{{'return_information' | translate}}</a>
                          <template v-for="label in shipping.labels">
                            <a class="btn btn-outline" :href="label.shipping_label_path" target="_blank"><i class="fa fa-print mr-5"></i>{{label.type | translate}}</a>
                          </template>
                          <template v-for="label in shipping.labels">
                            <a type="button" :href="label.tracking_url" target="_blank" class="btn btn-outline">
                              <i class="fa fa-qrcode mr-5"></i>{{label.type === 'shipping' ? 'order_tracking' : 'return_tracking' | translate}}
                            </a>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>
                  <template v-for="item, index in store.lines">
                    <template v-if="item && item.status">
                      <div>
                        <div class="col-xs-12">
                          <span class="mr-5 text-muted pull-right"><strong>#{{index+1}}</strong></span>
                          <span :class="item.status.style"><i :class="item.status.icon"></i>{{item.status.label| translate}}</span>
                          <span v-if="item.reductions.length > 0">{{item.return_id > 0 ? 'MIT' : 'OHNE'}} WB</span>
                        </div>
                        <div class=" col-xs-12" v-if="item.cases && item.cases.find(c => {return c.status === 'open'})">
                          <template v-for="r in item.cases">
                            <div class="callout bg-primary mt-10">
                              <div class="row">
                                <div class="col-xs-12">
                                  <h4 class="mt-0">{{'partial_refunded' | translate}}</h4>
                                </div>
                                <div class="col-lg-6 col-xs-12">
                                  <p>{{'reason_refund' | translate}}: {{r.reason}}<br>{{'refunded_amount' | translate}}: {{r.refund_amount | currency}}</p>
                                </div>
                                <div class="col-lg-6 col-xs-12 text-right">
                                  <button @click="openRefundModal(r)" type="button" data-toggle="modal" data-target="#refundModal" class="btn btn-sm btn-default">Accept/Decline</button>
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="clearfix margin"></div>
                        <div class="col-lg-1 col-md-2 col-sm-3 col-xs-6">
                          <a target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${item.sku.split('-')[0]}.html`">
                            <img class="img-preview" :src="item.image_url === null ? '/static/img/no-image-100x100.jpg' : item.image_url">
                          </a>
                        </div>
                        <div class="clearfix mb-10 visible-sm visible-xs"></div>
                        <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                          <strong>{{item.title}}</strong><br>
                          <a class="underline text-primary" target="_blank" :href="`http://www.schuhe.de/schuh/s-cp${item.sku.split('-')[0]}.html`">{{item.sku}}</a>
                          <template v-if="order.sales_channel === 'zalando'">
                            <br/>
                            <span>#</span>
                            <a target="_blank" :href="`http://www.zalando.de/kinder/?q=${getZalandoCode(item.mp_item_id)}`">{{getZalandoCode(item.mp_item_id)}}</a>
                          </template>
                          <br><span>{{item.ean}}</span> <span>#</span>{{`${item.erp_sku_addition.split("|||")[0]} ||| ${item.erp_sku_addition.split("|||")[4]} ||| ${item.erp_sku_addition.split("|||")[5]}`}}
                        </div>
                        <div class="clearfix mb-10 visible-sm visible-xs"></div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                          <strong>{{'size' | translate}}: </strong>{{item.sku.split('-')[1]}}<br>
                          <strong>{{'color' | translate}}: </strong>{{item.erp_sku_addition.split("|||")[3]}}<br>
                          <strong>Ext-Rechn.-Nr.: </strong>{{order.ext_order_id}}
                        </div>
                        <div class="clearfix mb-10 visible-md visible-xs"></div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                          <strong>{{'selling_price' | translate}}: </strong><span :class="item.selling_price >= item.expected_price ? 'text-success' : 'text-danger'">{{item.selling_price | currency}}</span><br>
                          <strong>{{'original_price' | translate}}: </strong><span>{{item.expected_price | currency}}</span><br>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                          <strong>{{'parent_line_id' | translate}}: </strong><span>{{item.parent_id}}</span><br>
                          <strong>{{'child_line_id' | translate}}: </strong><span>{{item.id}}</span><br>
                        </div>
                        <div class="clearfix mb-10 visible-md visible-xs"></div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-xs-12">
                          <template v-if="item.reductions && item.reductions.length > 0">
                            <strong><i class="fa fa-warning mr-5 text-additional"></i>{{'price_reduction' | translate}}:</strong>
                            <ul class="text-additional small list-unstyled">
                              <li v-for="r in item.reductions">{{'refund_amount' | translate}}: - {{r.refund_amount | currency}}</li>
                              <li><strong>{{'amount' | translate}}: </strong>{{item.refundable_amount | currency}}</li>
                            </ul>
                          </template>
                        </div>
                        <div class="clearfix mb-10"></div>
                        <div class="col-xs-12">
                          <div class="box-controls">
                            <div class="btn-group no-padding btn-sm">
                              <button :disabled="getLabelTransitions(store.shippings, item.shipping_id).length === 0" type="button" data-toggle="modal" data-target="#label-history" class="btn btn-sm btn-default" @click="prepareLabelHistory(store, item)"><i class="fa fa-truck mr-5"></i>{{'label_history' | translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#store-history" aria-expanded="false" aria-controls="coll1" @click="storeTransitions = store.transitions" class="btn btn-sm btn-default"><i class="fa fa-clock-o mr-5"></i>{{'history' | translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#item-history" aria-expanded="false" aria-controls="coll1" @click="prepareLineTransitions(store.transitions, item.transitions) " class="btn btn-sm btn-default"><i class="fa fa-star mr-5"></i>{{'store_ranking' | translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#reminder-modal" :disabled="item.recorded_return === 1 || item.recorded_complain === 1" :class="['btn', 'btn-sm',  item.recorded_return === 0 ? 'btn-success' : 'btn-danger', 'pull-right']" @click="selectedLine = item"><i class="fa fa-bell-o mr-5"></i>{{item.recorded_return === 0 ? 'return_reminder_act'  : 'return_reminder_deact'| translate}}</button>
                              <button type="button" data-toggle="modal" data-target="#sapDocHistoryModal"  @click="openSapDocHistoryModal(item.id)" class="btn btn-default btn-sm">
                                <i class="fa fa-exchange mr-5"></i>{{"sap_doc_history"|translate}}
                              </button>
                              <div class="input-group-btn">
                                <button :disabled="checkDisabled(item)" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{'administration' | translate}}<span class="fa fa-caret-down ml-5"></span></button>
                                <ul class="dropdown-menu">
                                  <li v-if="item.status_transitions.partial_refundable"><a type="button" data-toggle="modal" href="#refundModal3" class="text-primary" @click="openRefundModal(item)"><i class="fa fa-euro mr-5"></i>{{'partial_refund'|translate}} {{'with_stock' | translate}}</a></li>
                                  <li v-if="item.status_transitions.returnable"><a type="button" data-toggle="modal" href="#returnModal" @click="lineForReturn = item.id" class="text-warning"><i class="fa fa-reply mr-5"></i>Retoure buchen</a></li>
                                  <li v-if="item.status_transitions.cancelable"><a type="button" data-toggle="modal" href="#cancelModal" class="text-danger" @click="lineForCancel = item.id"><i class="fa fa-ban mr-5"></i>Stornieren</a></li>
                                  <template v-if="item.status_transitions.price_reduceable">
                                    <li class="divider"></li>
                                    <li><a type="button" data-toggle="modal" href="#refundModal2" class="text-primary" @click="openRefundModal2(item)"><i class="fa fa-euro mr-5"></i>{{'partial_refund'|translate}} {{'without_stock' | translate}}</a></li>
                                  </template>
                                </ul>
                              </div>
                              <div class="mt-10" v-if="$store.getters.user.roles.admin === true">
                                <template v-if="typeof item.sap !== 'undefined'">
                                  <template v-if="typeof item.sap.shipping !== 'undefined'">
                                    <button @click="resendShipping(item.sap.shipping.id, item.sap.shipping.lock_id)" type="button" class="btn btn-sm btn-default mr-5"><i class="fa fa-clock-o mr-5"></i>{{'resend_sap_inbound_shipping' | translate}}</button>
                                  </template>
                                  <template v-if="typeof item.sap.return !== 'undefined'">
                                    <button @click="resendReturn(item.sap.return.id, item.sap.return.lock_id)" type="button" class="btn btn-sm btn-default mr-5"><i class="fa fa-star mr-5"></i>{{'resend_sap_inbound_return' | translate}}</button>
                                  </template>
                                  <template v-if="typeof item.sap.reduction !== 'undefined'">
                                    <button @click="resendReduction(item.sap.reduction.id, item.sap.reduction.lock_id)" type="button" class="btn btn-sm btn-default mr-5"><i class="fa fa-bell-o mr-5"></i>{{'resend_sap_inbound_reduction' | translate}}</button>
                                  </template>
                                </template>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-xs-12 pull-right">
                                <button type="button" :disabled="loadingLine" :class="['btn', 'btn-sm',  item.recorded_complain === 1 ? 'btn-success' : 'btn-danger', 'pull-right']" @click="toggleComplaint(item)"><i :class="['fa', loadingLine ? 'fa-spinner fa-spin' : 'fa-bell-o', 'mr-5']"></i>{{item.recorded_complain === 1 ? 'complaint_activate'  : 'complaint_deactivate'| translate}}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="clearfix mb-10"></div>
                      </div>
                    </template>
                  </template>
                </div>
              </template>
              <hr>
            </div>
            <div class="box-footer with-border">
              <div class="row" v-if="order.invoices && order.invoices.length> 0">
                <div class="col-xs-12">
                  <p><strong><i class="fa fa-file-pdf-o mr-5"></i>{{'invoices' | translate}}</strong></p>
                  <div>
                    <template v-for="invoice in order.invoices">
                      <a type="button" class="btn btn-outline" style="margin: 4px" :href="invoice.invoice_path" target="_blank"><i class="fa fa-file-pdf-o mr-5"></i>{{invoice.type === 'payment' ? 'invoice' : 'invoice_correct' | translate}}</a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <order-notes :id="$route.params.id"></order-notes>
        </div>
      </div>
    </template>
  </section>
</template>
<script>
  import OrderHistory from '../tools/OrderHistory.vue'
  export default {
    data () {
      return {
      	selectedLine: {},
      	editMail: false,
        editPhone: false,
      	errorLabel: 0,
        returnMessage: '',
	      notFound: false,
        formstate: {},
        messages: [],
        selectedShipping: {},
        selectedReturn: {},
        reload: false,
        selectedTransitions: {},
        storeTransitions: {},
        selectedLabelTransitions: {},
        fixed: [],
        show: false,
        invoiceForm: {},
        cancelReason: 'covfefe',
        serverURI: `${this.$parent.serverURI}orders`,
        streetName: '',
        loading: true,
        streetNumber: '',
        translate: this.$parent.translate,
        stores: {},
        parcel: 1,
        lineForCancel: 0,
        itemForCancel: 0,
        imagesForRefund: [],
        order: {
          customer: {
            billing_address_addition: '',
            billing_address_line_1: '',
            billing_city: '',
            billing_country: '',
            billing_first_name: '',
            billing_last_name: '',
            billing_zip_code: '',
            company_id: '',
            created_at: '',
            currency: '',
            customer_email: '',
            customer_id: '',
            customer_phone_number: '',
            delivery_address: '',
            delivery_address_line_1: '',
            delivery_address_line_2: '',
            delivery_address_line_3: '',
            delivery_address_addition: '',
            delivery_city: '',
            delivery_country: '',
            delivery_first_name: '',
            delivery_last_name: '',
            delivery_zip_code: ''
          },
          ext_order_id: '',
          id: '',
          invoice_city: '',
          invoice_company: '',
          invoice_country: '',
          invoice_name: '',
          invoice_street: '',
          invoice_street_no: '',
          invoice_zip_code: '',
          label_care_of: '',
          label_city: '',
          label_company: '',
          label_country: '',
          label_name: '',
          label_street: '',
          label_street_no: '',
          label_zip_code: '',
          number_of_lines: '',
          order_date: '',
          order_total: '',
          order_type: '',
          payment_method: '',
          sales_channel: '',
          labels: [],
          sales_channel_id: '',
          shipping_city: '',
          shipping_country: '',
          shipping_name: '',
          shipping_street: '',
          shipping_street_no: '',
          shipping_zip_code: '',
          items: {},
          stores: []
        },
        sapdochistory: [],
        payments: [],
        enhancedOrder: {},
        alerts: [],
        inboundData: {},
        loadingLine: false,
        callAPI: this.$parent.callAPI,
        pepe () {
          this.updateOrder()
        },
	      getIcon (mp) {
		      return mp === 'schuhede' ? 'fa fa-schuhe' : `fa fa-${mp}`
	      },
        checkDefaultFields () {
          let shippingLabel = {
            label_name: this.order.label_name,
            label_care_of: this.order.label_care_of,
            label_street: this.order.label_street,
            label_street_no: this.order.label_street_no,
            label_city: this.order.label_city,
            label_zip_code: this.order.label_zip_code
          }
          let billingLabel = {
            invoice_name: this.order.invoice_name,
            invoice_care_of: this.order.invoice_care_of,
            invoice_street: this.order.invoice_street,
            invoice_street_no: this.order.invoice_street_no,
            invoice_city: this.order.invoice_city,
            invoice_zip_code: this.order.invoice_zip_code
          }
          let alertMsg = 'There is a problem in the billing address format. Please edit the address manually to proceed the order.'
          let alert = {type: 'danger', message: this.translate(alertMsg) || alertMsg}
          for (let x in shippingLabel) {
            if (shippingLabel[x] === '') {
              if (x === 'label_care_of' && (shippingLabel.label_street === 'PACKSTATION' || shippingLabel.label_street === 'POSTFILIALE')) {
                this.alerts.push(alert)
              } else if (x !== 'label_care_of') {
                this.alerts.push(alert)
              }
            }
          }
          for (let y in billingLabel) {
            if (billingLabel[y] === '') {
              if (y === 'invoice_care_of' && (billingLabel.invoice_street === 'PACKSTATION' || billingLabel.invoice_street === 'POSTFILIALE')) {
                this.alerts.push(alert)
              } else if (y !== 'label_care_of') {
                this.alerts.push(alert)
              }
            }
          }
        }
      }
    },
    components: {
      orderHistory: OrderHistory
    },
    methods: {
      getObjectData (stringdata) {
        let output = ''
        let parsedData = ''
        try {
          parsedData = JSON.parse(stringdata)
        } catch (e) {}
        if (typeof parsedData === 'string' || parsedData instanceof String) {
          return parsedData
        }
        for(let prop in parsedData) {
          output += parsedData[prop]+"<br />"
        }
        return output
      },
      toggleComplaint (line) {
        this.loadingLine = true
        let value = line.recorded_complain === 1
        API.put(`observation/complains/${line.id}`, {complained: !value})
          .then(res => {
            this.loadingLine = false
            line.recorded_return = 1
            line.recorded_complain = line.recorded_complain === 1 ? 0 : 1
          })
          .catch(error => {
            this.loadingLine = false
          })
      },
      reIndexOrder (orderId) {
        if (this.$store.getters.user.roles.admin === true) {
          API.put(`orders/${orderId}/reindex`, {})
            .then(response => {
              this.$store.commit('pushAlert', {
                dismiss: 4,
                type: 'success',
                message: 'Update Successful',
                icon: 'icon fa fa-check',
                show: true
              })
            })
            .catch(error => {
              this.alerts.push({
                dismiss: 4,
                type: 'danger',
                message: 'Something went wrong',
                icon: 'fa fa-ban',
                show: true
              })
            })
        }
      },
      resendShipping (lineId, lockId) {
        API.put(`/orders/sap/inbounds/resend/shipping/${lineId}`, {'lock_id': lockId})
          .then(res => {
            this.success()
          })
      },
      resendReturn (lineId, lockId) {
        API.put(`/orders/sap/inbounds/resend/return/${lineId}`, {'lock_id': lockId})
          .then(res => {
            this.success()
          })
      },
      resendReduction (lineId, lockId) {
        API.put(`/orders/sap/inbounds/resend/reduction/${lineId}`, {'lock_id': lockId})
          .then(res => {
            this.success()
          })
      },
      enhanceOrderData () {
        for (let store in this.inboundData) {
          for (let storeId in this.order.stores) {
            if (this.order.stores[storeId].id === parseInt(store)) {
              for (let line in this.order.stores[storeId].lines) {
                for (let inboundLine in this.inboundData[store]) {
                  if (this.order.stores[storeId].lines[line].id === parseInt(inboundLine)) {
                    let sapArray = {}
                    for (let type in this.inboundData[store][inboundLine]) {
                      if (type === 'OrderReturnLine') {
                        sapArray.return = {}
                        sapArray.return.lock_id = this.inboundData[store][inboundLine][type].sap_lock_id
                        sapArray.return.id = this.inboundData[store][inboundLine][type].id
                      }
                      if (type === 'OrderItemLine') {
                        sapArray.shipping = {}
                        sapArray.shipping.lock_id = this.inboundData[store][inboundLine][type].sap_lock_id
                        sapArray.shipping.id = this.inboundData[store][inboundLine][type].id
                      }
                      if (type === 'OrderPriceReduction') {
                        sapArray.reduction = {}
                        sapArray.reduction.lock_id = this.inboundData[store][inboundLine][type].sap_lock_id
                        sapArray.reduction.id = this.inboundData[store][inboundLine][type].id
                      }
                    }
                    this.order.stores[storeId].lines[line].sap = sapArray
                  }
                }
              }
            }
          }
        }
        this.enhancedOrder = this.order
      },
      sendRefund (e) {
        e.requested_reduction = parseFloat(e.requested_reduction.replace(',', '.'))
        API.post(`/orders/line/${this.lineForRefund.id}/case/partialRefund`, e)
          .then(res => {
            this.success()
          })
      },
      checkReturn (line) {
        return line.shipping_id > 0 && (line.cases.length === 0 || typeof line.cases.find(e => { return e.status === 'partial_refund' }) !== 'undefined') && item.cancellation_id === 0
      },
      checkThis (item) {
        return (this.order.sales_channel === 'schuhede' || this.order.sales_channel === 'schuhede-parent' || this.order.sales_channel === 'schuhede-amazon' || this.order.sales_channel === 'amazon') && item.shipping_id > 0 && item.return_id === 0
      },
      checkDisabled (line) {
        return line.return_id > 0 || line.cancellation_id > 0 || this.allFalse(line.status_transitions)
      },
      allFalse (obj) {
        for (let a in obj) {
          if (obj[a] === true) {
            return false
          }
        }
        return true
      },
      prepareLabelHistory (store, item) {
        this.selectedLabelTransitions = store.shippings.filter(e => e.id === item.shipping_id)[0].labels
        this.selectedShipping = this.getShipping(store.shippings, item.shipping_id, 'shipping')
        this.selectedReturn = this.getShipping(store.shippings, item.shipping_id, 'return')
      },
      sendEdit (id, store) {
        API.put(`accounting/companies/${id}`, store)
          .then(response =>{
            let alert = {dismiss: 4, type: 'success', message: 'Update Successful'}
            this.alerts.push(alert)
          })
          .catch(error =>{
            if (this.$parent.checkError(error)) {
              error = error.response.data.error
              this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: error.message})
            }
          })
      },
      retry (id) {
        API.put(`monitoring/labels/failed/${id}`)
          .then(response => {
            this.errorLabel = 0
            this.alert(response)
          })
          .catch(error => {
            this.alert(error)
          })
      },
      payload () {
        $('#openPayload').click()
      },
      success () {
        let alert = {
          status: 200
        }
        this.alert(alert)
      },
      alert (value) {
        let alert
        if (value.status === 200 || value.status === 204 || value.status === 202) {
          alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
        } else if (value.status === 0) {
          alert = {dismiss: 4, type: 'warning', message: 'Not modified', icon: 'icon fa fa-warning', show: true}
        } else if (value.status === 304) {
	        alert = {dismiss: 4, type: 'warning', message: 'Sorry! the label is already being processed. Please wait and retry later if necessary', icon: 'icon fa fa-warning', show: true}
        } else {
          alert = {dismiss: 4, type: 'danger', message: `There was an error: ${value.body.message}`, icon: 'icon fa fa-ban', show: true}
        }
        this.$store.commit('pushAlert', alert)
        this.updateOrder()
      },
      getZalandoCode (url) {
        let aux = url.split('-')
        aux = `${aux[0]}-${aux[1].substr(0, 3)}`
        return aux
      },
      getShipping (shippings, id, cond) {
        let ret
        shippings.forEach(function (s) {
          if (s.id === id) {
            s.labels.forEach(function (l) {
              if (l.type === cond) {
                ret = l.tracking_url
              }
            })
          }
        })
        return ret
      },
      getLabelTransitions (shippings, id) {
        let ret = []
        shippings.forEach(s => {
          if (s.id === id) {
            s.labels.forEach(l => {
              ret.push({type: l.type, transitions: l.transitions})
            })
          }
        })
        return ret
      },
      cancelOrder (e) {
        let url = `orders/line/${this.lineForCancel}/cancel`
        API.put(url, {reason: e[0], message: e[1]})
          .then(response => {
            $('#closeCancelModal').click()
            this.updateOrder()
          })
          .catch(error => {
            $('#closeCancelModal').click()
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.updateOrder()
            this.$store.commit('pushAlert', alert)
          })
      },
      returnOrder (e) {
        let url = `orders/line/${this.lineForReturn}/return`
        API.put(url, {status: 'accepted', reason: e[0], message: e[1]})
          .then(response => {
            $('#closeReturnModal').click()
            this.updateOrder()
          })
          .catch(error => {
            $('#closeReturnModal').click()
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.updateOrder()
            this.$store.commit('pushAlert', alert)
          })
      },
      refundOrder (e) {
        let value = e[1]
        let url = `orders/line/case/${this.lineForRefund.id}/${e[0]}`
        API.put(url, {value: value.split('.').join('').replace(',','.')})
          .then(response => {
          $('#closeRefundModal').click()
          this.updateOrder()
        })
          .catch(error => {
          $('#closeRefundModal').click()
          let alert = {type: 'danger', dismiss: 4, message: error.response.data.message}
          this.updateOrder()
          this.$store.commit('pushAlert', alert)
        })
      },
      openRefundModal (refundCase) {
        this.lineForRefund = refundCase
        this.imagesForRefund = refundCase.images
      },
      openRefundModal2 (item) {
        this.selectedLine = item
      },
      openPaymentHistoryModal(orderId){
          var url="orders/sap/payments/"+orderId;
          API.get(url).then(response=>{
              this.payments=response.data;
          })
          .catch(error => {
              console.log(error)
          })
      },
      openSapDocHistoryModal(lineId){
        var url="/orders/sap/idochistory/"+lineId;
        API.get(url).then(response=>{
          this.sapdochistory=response.data
        }) .catch(error => { console.log(error) })
      },
      cancel () {
        this.updateOrder()
      },
      checkLabelsCall () {
        API.get(`orders/${this.$route.params.id}/shippings/check`)
            .then(response => {
              this.shipStatus = response.data.status
              if (response.data.status === 'done' || response.data.status === 'error') {
                this.loading = false
                if (response.data.status === 'error') {
                  this.showErrorButton = true
                  let alert = {type: 'danger', dismiss: true, message: this.translate('labels_error') || 'something failed'}
                  this.$store.commit('pushAlert', alert)
                } else {
                  this.updateOrder()
                }
              } else {
                setTimeout(this.checkLabelsCall, 5000)
              }
            })
            .catch(error => { console.log(error) })
      },
      postData () {
        this.sendData(this.order)
          .then(response => {
        })
          .catch(error => { console.log(error) })
      },
      getLineStatus (line) {
        if (Object.keys(line.cases).length > 0) {
          if (typeof line.cases.find(s => { return s.status === 'accepted' }) !== 'undefined') {
            return {label: 'partial_refund_accepted', style: 'label label-additional', icon: 'fa fa-euro mr-5'}
          } else if (typeof line.cases.find(s => { return s.status === 'declined' }) !== 'undefined') {
              return {label: 'partial_refund_declined', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
            }
          return {label: 'partial_refunded', style: 'label label-primary', icon: 'fa fa-money mr-5'}
        }
        if (line.cancellation_id > 0) {
          return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
        }
        if (line.return_id > 0) {
          return {label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
        }
        if (line.shipping_id > 0) {
          return {label: 'shipped_status', style: 'label label-success', icon: 'fa fa-check mr-5'}
        }
        return {label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'}
      },
      getStatus (order) {
        if (order.transitions.length > 0) {
          order.status = order.transitions[order.transitions.length - 1].transition
          if (order.status === 'mp_cancellation') {
            return {label: 'mp_cancellation_status', style: 'label label-danger', icon: 'fa fa-exclamation-triangle mr-5'}
          }
          if (order.status === 'initial') {
            return {label: 'reserved', style: 'label label-primary', icon: 'fa fa-bookmark mr-5'}
          }
          if (order.status === 'canceled' || order.status === 'cancelled') {
            return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
          }
          if (order.status === 'returned') {
            return {label: 'returned_status', style: 'label label-warning', icon: 'fa fa-reply mr-5'}
          }
          if (order.status === 'fulfilled') {
            return {label: 'shipped_status', style: 'label label-success', icon: 'fa fa-check mr-5'}
          }
          if (order.status === 'open_history' || order.status === 'approved') {
            return {label: 'open', style: 'label label-info', icon: 'fa fa-sign-in mr-5'}
          }
        } else {
          return {label: 'canceled', style: 'label label-danger', icon: 'fa fa-ban mr-5'}
        }
      },
      updateRecordedReturn () {
        API.put(`orders/line/${this.selectedLine.id}/record/returned`, {order_id: this.order.id, note: `Retouren-Erinnerung deaktiviert für Item: ${this.selectedLine.id}\n\n${this.returnMessage}`})
          .then(res => {
            this.returnMessage = ''
            this.updateOrder()
            $('#closeReminder').click()
          })
          .catch(error => {
            console.log(error)
          })
      },
      updateOrder () {
        this.show = false
        this.reload = !this.reload
        this.itemForCancel = 0
        this.lineForCancel = 0
        this.cancelReason = 'out_of_stock'
        let url = `orders/${this.$route.params.id}`
        API.get(url)
          .then(response => {
            this.order = response.data
            this.order.status = this.getStatus(this.order)
            let main = []
            this.order.transitions.forEach(t => {
              let date = t.date.split(' ')
              if (!(date[0] in main)) {
                main[date[0]] = {date: date[0], transitions: []}
              }
              main[date[0]].transitions.push({event: t.transition, time: date[1]})
            })
            this.order.transitions = []
            for (let k in main) {
              this.order.transitions.push(main[k])
            }
            this.order.stores.forEach(x => {
            	let aux = []
              let approvedTransition = false
            	if (x.transitions.length > 0) {
		            x.transitions.forEach(t => {
                  if (t.transition === 'approved') {
                    approvedTransition = t
                  }
			            let date = t.date.split(' ')
			            if (!(date[0] in aux)) {
				            aux[date[0]] = {date: date[0], transitions: []}
			            }
			            aux[date[0]].transitions.push({
                    event: t.transition,
                    time: date[1],
                    ranking: t.points.toString().replace('.', ','),
                    id: t.id,
                    message: t.message,
                    original_points: t.original_points,
                    created: t.created_by,
                    updated: t.updated_by})
		            })
		            x.transitions = []
		            for (let a in aux) {
			            x.transitions.push(aux[a])
		            }
              }
              x.lines.forEach(y => {
                let aux = []
                if (this.order.status.label === 'open' || this.order.status.label === 'shipped_status' || y.cancellation_id > 0) {
                  y.status = this.getLineStatus(y)
                } else {
                  if (this.order.status.label === 'mp_cancellation_status') {
                    y.status = {label: 'mp_cancellation_status', style: 'label label-primary', icon: 'fa fa-exclamation-triangle mr-5'}
                  } else {
                    y.status = this.order.status
                  }
                }
                if (y.transitions.length > 0) {
                  if (approvedTransition) {
                    y.transitions.push(approvedTransition)
                  }
                  y.transitions.forEach(t => {
                    let date = t.date.split(' ')
                    if (!(date[0] in aux)) {
                      aux[date[0]] = {date: date[0], transitions: []}
                    }
                    aux[date[0]].transitions.push({event: t.transition, time: date[1],
                      ranking: t.points.toString().replace('.', ','),
                      id: t.id,
                      message: t.message,
                      original_points: t.original_points,
                      created: t.created_by,
                      updated: t.updated_by})

                  })
                  y.transitions = []
                  for (let a in aux) {
                    aux[a].transitions.sort((a,b) => {
                      if (a.time > b.time) {
                        return 1
                      }
                      if (a.time < b.time) {
                        return -1
                      }
                      return 0
                    })
                    y.transitions.push(aux[a])
                  }
                }
                if (y.shipping_id === 0 && y.cancellation_id === 0) {
                  this.show = true
                }
              })
            })
            if (this.$route.query.label) {
            	API.get(`monitoring/labels/failed/${this.$route.query.label}`)
                .then(res => {
                  this.errorLabel = res.data
                  if (this.errorLabel.message.substr(0,1) === '{') {
                    let messages = JSON.parse(this.errorLabel.message)
                    for (let x in messages.errors) {
	                    this.messages.push(messages.errors[x])
                    }
                  } else {
                    this.messages.push(this.errorLabel.message)
                  }
                })
                .catch(error => {
                  console.log(error)
                })
            }
            if (this.$store.getters.user.roles.admin === true) {
              API.get(`orders/sap/inbounds/${this.$route.params.id}`)
                .then(response => {
                  this.inboundData = response.data
                  this.enhanceOrderData()
                })
            } else {
              this.enhancedOrder = this.order
            }
            this.checkDefaultFields()
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.notFound = error.response.status === 404
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            if (error.response.status !== 404 ) {
              this.$store.commit('pushAlert', alert)
            }
          })
      },
      prepareLineTransitions (store, item) {
        this.selectedTransitions = item
        this.storeTransitions = store
      }
    },
    mounted () {
      this.updateOrder()
    },
    watch: {
      order () {},
	    '$route.params.id' () {
		    this.notFound = false
		    this.updateOrder()
	    }
    }
  }
</script>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
    .italic {
      font-style: italic;
    }
    input.normal{color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4)}
    input.normal{background:#202227}
</style>



// WEBPACK FOOTER //
// src/components/views/OrderSingle.vue